// src/pages/Login.jsx
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import * as z from 'zod';

import { Button } from 'components/Elements';
import { Form, InputField } from 'components/Form';
import { useAuth } from 'lib/auth';
import { AccountLayout } from 'components/Layout';

const schema = z.object({
  email: z.string().email('Enter a valid email').min(1, 'Email is required'),
  password: z.string().min(1, 'Password is required'),
});

export function Login() {
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const navigate = useNavigate();

  return (
    <AccountLayout
      title="Sign In"
      description="Input your credentials to sign in to your dejunk account."
    >
      <Form
        onSubmit={async (values) => {
          setLoading(true);
          try {
            await login({
              email: values.email,
              password: values.password,
            });
            navigate('/app/home');
          } catch (error) {
            setLoading(false);
          }
        }}
        schema={schema}
      >
        {({ register, formState }) => (
          <div className="flex flex-col space-y-4">
            <InputField
              type="email"
              label="Email"
              error={formState.errors['email']}
              registration={register('email')}
              placeholder="Email address"
            />

            <InputField
              type="password"
              label="Password"
              error={formState.errors['password']}
              registration={register('password')}
              placeholder="Password"
            />

            {/* <div className="text-center text-sm text-[#0f3c0d]">
              <Link to="/account/forgot-password">Forgot password?</Link>
            </div> */}
            <Button isLoading={loading} type="submit" className="w-full">
              Continue
            </Button>
            <div className="text-center">
              <div className="relative flex items-center justify-center my-3">
                <div className="absolute w-full border-t border-gray-300" />
                <span className="relative bg-white px-3 text-xs text-gray-500">or</span>
              </div>
              <Link to="/auth/register" className="text-[#0f3c0d]">
                Do you need an account? Sign up today
              </Link>
            </div>
          </div>
        )}
      </Form>
    </AccountLayout>
  );
}

Login.propTypes = {
  onSuccess: PropTypes.func,
};
